export default __webpack_public_path__ + "be37025c6a07109ff3e373101a9720c4.glb";